import icon from "~/components/ui/icons/svg/swatch-crossout.svg";

export const SwatchCrossout = ({ className }: { className?: string }) => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <use xlinkHref={`#${icon}`} />
    </svg>
  );
};
